// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_bc-3";
export var contentContainer = "_bc-0";
export var editorContainer = "_bc-1";
export var quillInputForm = "_bc-2";
export var zoneDivider = "_bc-4";